module.exports = __webpack_public_path__ + "img/mind_skeleton_12.baa633c7.png";